// extracted by mini-css-extract-plugin
module.exports = {"GameWrapper":"Game_GameWrapper__2wttS","Active":"Game_Active__1nrXX"};